export { default as GDMFeedbackModal } from './GDMFeedbackModal';

export type { GDMFeedbackModalComponent, GDMFeedbackModalStyles } from './GDMFeedbackModal.type';
